import React from 'react';

import Routes from './components/Routes';

// At the moment this only has routes, but in future I might add React context
// providers such as React-Intl and Apollo
const App = () => <Routes />;

export default App;
